module.exports = __webpack_public_path__ + "img/zgys.d65fc5cb.png";